export enum DiscountTypeEnum {
    Simple = 'simple',
    Quantity = 'quantity',
}
